
import { Component, Vue } from 'vue-property-decorator';

import Form5ProcessHeader from "@/components/process/Form5/components/Form5ProcessHeader.vue";
import Form5 from "@/components/process/Form5/components/pdf/Form5.vue"

import { form5StatusInfoType } from '@/types/Information/Form5';

@Component({
    components:{
        Form5ProcessHeader,
        Form5
    }
})
export default class PreviewForm5 extends Vue {

    stepsCompleted = {} as form5StatusInfoType; 
    
    dataReady = false;
    pdfReady = false;

    mounted() {
        this.dataReady = false;
        this.stepsCompleted = {
            first: true,
            second: false,
            third: false
        }
        this.dataReady = true;       
    }

    public navigateToSubmitPage() {
        this.$router.push({name: "proceed-form5"}); 
    }
}
